import React from 'react';
import { GuidePageQuery } from '../../generated/types';
import { hrefFor } from '../../routers';
import { usePLPParams } from '../../hooks/usePLPParams';
import { PageFilterLink } from './PageFilterLink';
import { PageFilterPanel } from './PageFilterPanel';

import './PageFilterPages.scss';

type DisplayPage = NonNullable<GuidePageQuery['displayPage']>;

type PageFilterCategoryProps = {
  guideSubPages?: DisplayPage['guideSubPages'];
  mobile?: boolean;
  onClose: () => void;
};

export const PageFilterPages: React.FC<PageFilterCategoryProps> = ({
  mobile = false,
  onClose,
  guideSubPages
}) => {
  const {
    params: { guideSlug }
  } = usePLPParams();
  const content =
    guideSubPages &&
    guideSubPages.map(
      page =>
        page &&
        page.slug && (
          <PageFilterLink
            selected={guideSlug === page.slug}
            key={page.slug}
            to={hrefFor.GuidePage({ guideSlug: page.slug })}
            onClick={onClose}
          >
            <span>{page.name}</span>
          </PageFilterLink>
        )
    );

  if (mobile) {
    return (
      <PageFilterPanel onClose={onClose} title="Pages">
        {content}
      </PageFilterPanel>
    );
  }

  return (
    <div className="PageFilterPages">
      <div className="PageFilterPages__title">Pages</div>
      {content}
    </div>
  );
};
